import { createAsyncThunk } from '@reduxjs/toolkit';
import AuthCookie from '@features/userFlow/utils/AuthCookie';
import { RootState } from '../../state';
import { fetchWithRetries } from '../../utils/fetchWithRetries';

export const refreshAccessToken = createAsyncThunk<string, void, { state: RootState }>(
    'auth/refreshAccessToken',
    async (_, { rejectWithValue }) => {
        const refreshToken = AuthCookie.get();
        if (!refreshToken) {
            return rejectWithValue('No refresh token available');
        }

        try {
            const response = await fetchWithRetries('/api/user/token/refresh/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ refresh: refreshToken }),
            });
            if (!response.ok) {
                return rejectWithValue(`Failed to refresh token: ${response.statusText}`);
            }
            const data = await response.json();
            return data.access as string;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : String(error));
        }
    },
);
